module.exports = __webpack_public_path__ + "img/bg2.a0ee189c.jpg";